/* eslint-disable react/prop-types */
import React from 'react';
import ReactMarkdown from 'react-markdown';
export const MarkdownText = ({ markdownText, embeddedNode, style, }) => {
    return (React.createElement("div", null,
        React.createElement(ReactMarkdown, { components: {
                p: ({ node, ...props }) => (React.createElement("p", { ...props, style: style },
                    props.children,
                    embeddedNode && embeddedNode)),
            } }, markdownText)));
};
